import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../../Context/InshData";
import { uri } from "../../../../../help/Api";
import LoadingPage from "../../../../../services/LoadingPage";
import CurrencySalesProfit from "./CurrencySalesProfit";
import { useTranslation } from "react-i18next";
const defaultAutos = {
  Safes: [],
};
export default function CurrencySalesProfitCon() {
  const { t } = useTranslation(["forms"]);
  const [branch, setBranch] = useState({ id: -1, name: t("all") });

  const tb = {
    wait: true,
    Safes: true,
    Customers: true,
    Currencies: true,
    Branches: true,
    groups: true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms: {
       safe: -1 ,
       branch: branch.id == -1 ? sto.branchi : branch.id ,
       iempid: sto.empi,
      },
  };
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb,
    [branch]
  );

  useEffect(() => {}, [AutoOptions]);

  if (fetchAll || !AutoOptions?.Safes) return <LoadingPage />;

  return (
    <CurrencySalesProfit
      {...{
        AutoOptions: AutoOptions?.Safes ? AutoOptions : defaultAutos,
        branch,
        setBranch
      }}
    />
  );
}
